import { ifAuthenticated } from '../utils/authorization.js';
import Dashboard from '../views/Dashboard.vue';
import Orders from '../views/Orders.vue';
import Order from '../views/Order.vue';
import Activations from '../views/Activations.vue';
import Deliveries from '../views/Deliveries.vue';
import Settings from '../views/Settings.vue';

export default [
    // Dashboard
    // {
    //     path: '/dashboard',
    //     name: 'dashboard',
    //     component: Dashboard,
    //     beforeEnter: ifAuthenticated,
    //     meta: {
    //         title: 'dashboard.pageTitle',
    //     },
    // },

    // Orders
    {
        path: '/orders',
        name: 'orders',
        component: Orders,
        beforeEnter: ifAuthenticated,
        meta: {
            title: 'orders.pageTitle',
        },
    },
    // {
    //     path: '/orders/:id',
    //     name: 'order',
    //     component: Order,
    //     beforeEnter: ifAuthenticated,
    //     meta: {
    //         title: 'orders.pageTitle',
    //     },
    // },

    // Activations
    {
        path: '/activations',
        name: 'activations',
        component: Activations,
        beforeEnter: ifAuthenticated,
        meta: {
            title: 'activations.pageTitle',
        },
    },

    // Deliveries
    // {
    //     path: '/deliveries',
    //     name: 'deliveries',
    //     component: Deliveries,
    //     beforeEnter: ifAuthenticated,
    //     meta: {
    //         title: 'deliveries.pageTitle',
    //     },
    // },

    // Settings
    // {
    //     path: '/settings',
    //     name: 'settings',
    //     component: Settings,
    //     beforeEnter: ifAuthenticated,
    //     meta: {
    //         title: 'settings.pageTitle',
    //     },
    // },
];
